import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import InfoSvg from './info.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const InfoIcon = (props: any) => <Icon component={InfoSvg} {...props} />;

export const InfoIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<InfoSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
InfoIconButton.displayName = 'InfoIconButton';
